import {configure} from 'mobx'
configure({
  useProxies: 'never',
})

import('./bootstrap')
